import React, {Dispatch, SetStateAction} from "react";
import {VacatureModel} from "../../pages/api/vacature.model";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {handleLog} from "../logger.helper";

interface PaginationProps {
    vacatures: VacatureModel[];
    currentPage: number;
    totalPages: number;
    setCurrentPage: Dispatch<SetStateAction<number>>;
}

const Pagination: React.FC<PaginationProps> = ({vacatures, currentPage, totalPages, setCurrentPage}) => {

    const handlePrevPage = () => {
        handleLog("Clickrate_VacatureVorigePagina", "Vacatures", "Clickrate_VacatureVorigePagina");
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        handleLog("Clickrate_VacatureVolgendePagina", "Vacatures", "Clickrate_VacatureVolgendePagina");
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePage = (index) => {
        handleLog("Clickrate_VacaturePagina", "Vacatures", "Clickrate_VacaturePagina");
        if (currentPage !== index) {
            setCurrentPage(index);
        }
    };

    return (
        <>
            {vacatures.length !== 0 && (
                <div className="paginations">
                    <ul className="pager">
                        <li>
                            <a
                                href="#top-2"
                                className="prev-page pointer"
                                onClick={handlePrevPage}
                            >
                                <FontAwesomeIcon icon={faArrowLeft}/>
                            </a>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                            <li key={i}>
                                <a
                                    href="#top-2"
                                    className={`pointer ${currentPage === i + 1 ? "active-index" : ""}`}
                                    onClick={() => handlePage(i + 1)}
                                >
                                    {i + 1}
                                </a>
                            </li>
                        ))}
                        <li>
                            <a
                                href="#top-2"
                                className="next-page pointer"
                                onClick={handleNextPage}
                            >
                                <FontAwesomeIcon icon={faArrowRight}/>
                            </a>
                        </li>
                    </ul>
                </div>
            )}
        </>
    );
};

export default Pagination;
